<template>
  <li
    :class="{
      'frisbuy-gallery-post': true,
      'frisbuy-sale': hasSale,
      'frisbuy-video': post.media.length < 2 && post.media[0].videoUrl,
      'frisbuy-multipost': post.media.length > 1,
      [`frisbuy-provider-${ post.frisbuyPost.providerType }`]: settings.gallery.showProviderIcon && !isCensored
    }"
    @click="$emit('click')"
  >
    <div class="frisbuy-post-image">
      <div :class="{'frisbuy-invisible': invisible}" ref="photo" :style="{ 'background-image': `url(${ imageSource.imageHighRes }), url(${ imageSource.imageLowRes })` }">
      </div>
      <img ref="image" :data-image-src="getDomainSubstitute(imageSource.imageHighRes)" @load="loadHandler" @error="errorImageHandler"/>
        <div :class="{[`frisbuy-post-provider-${ post.frisbuyPost.providerType }`]: !isCensored}"></div>
    </div>
    <div class="frisbuy-post-desc">
      <span>Читать отзыв</span>
    </div>
      <div v-if="!postItemSettings.hideInfo" class="frisbuy-post-cover" :style="{ fontSize: `${adaptiveHeight}px`, display: `${coverDispay}` }">
          <span class="frisbuy-post-cover-name">{{ post.instagramPost.authorUser.fio || `@${post.instagramPost.authorUser.username}` }}</span>
          <div class="frisbuy-post-cover-social" v-if="post.frisbuyPost.providerType !== 'frisbuy'">
            <div>
                <img :src="`${envDomain}/images/objects/favorite.svg`">
                {{post.instagramPost.likeCountShort}}
            </div>
            <div v-if="!settings.hideCommentCount">
                <img :src="`${envDomain}/images/objects/comment-bubble.svg`">
                {{post.instagramPost.commentCountShort}}
            </div>
        </div>
        <div class="frisbuy-post-cover-logo">
          <img :src="envDomain + (post.frisbuyPost.hasLink ? '/images/widget/bag2.svg' : '/images/widget/zoom.svg')">
        </div>
    </div>
  </li>
</template>

<script>
// Components
import defaultPostItem from "@/gallery/postitem/postitem.vue";

export default {
  mixins: [defaultPostItem],

  emits: ["click"],
}
</script>
